"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const arrowforward = _ref => {
  let {
    title,
    description,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": (title ? `title-arrowforward` : '') + (description ? ` desc-arrowforward` : '') || undefined,
    role: "img"
  }), title && /*#__PURE__*/_react.default.createElement("title", {
    id: "title-arrowforward"
  }, title), description && /*#__PURE__*/_react.default.createElement("desc", {
    id: "desc-arrowforward"
  }, description), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.9441 1.62187L11.8744 1.73122C11.6683 2.10531 11.725 2.56675 12.023 2.87016L20.056 11.049L1.6875 11.05L1.57713 11.057C1.09725 11.1227 0.75 11.5243 0.75 12L0.756293 12.1106C0.810327 12.5824 1.20577 12.95 1.6875 12.95L20.057 12.949L12.023 21.1299L11.9441 21.2219C11.6594 21.6114 11.6952 22.1364 12.023 22.4702C12.3895 22.8433 12.9855 22.8433 13.352 22.4702L22.977 12.6702L23.0459 12.5913L23.1262 12.471L23.1724 12.3783L23.2164 12.2507L23.2307 12.192L23.2458 12.0868L23.2498 12.0092C23.2498 11.9057 23.2364 11.8128 23.2099 11.7245L23.1675 11.611L23.1065 11.4954C23.0629 11.4267 23.0225 11.3762 22.977 11.3299L13.352 1.52985L13.2472 1.43778C12.8754 1.15691 12.353 1.19388 12.023 1.52985L11.9441 1.62187Z",
    fill: "inherit"
  }));
};
var _default = exports.default = arrowforward;